import http from '@/utils/http.js' // 引入封装的request.js文件
import common from '@/config/common.js'

// 暴露出我们的接口请求,export导出
export function queryUnLoginChapterTree(data) {
    return http.request({
        url: common.url + '/papi/course_chapter/trees',
        method: 'get',
        params: data
    })
}


// 暴露出我们的接口请求,export导出
export function queryVideoUrl(data) {
    return http.request({
        url: common.url + '/papi/course_chapter/getVideoUrl',
        method: 'get',
        params: data
    })
}

// 暴更新学习视频时间
export function updateVideoUpdateTime(data) {
    return http.request({
        url: common.url + '/papi/learning_history/updateVideoUpdateTime',
        method: 'get',
        params: data
    })
}

// 获取章节播放信息
export function getStudyHistoryByChapterId(data) {
    return http.request({
        url: common.url + '/papi/learning_history/getStudyHistoryByChapterId',
        method: 'get',
        params: data
    })
}